module.exports = __webpack_public_path__ + "ipetbooking-landing/img/illustration02.13cf6f03.svg";